/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import MzTable from '../../common/MzTable'
import ErrorPage from '../../common/Error'
import { Sidebar } from 'primereact/sidebar'
import { BreadCrumb } from 'primereact/breadcrumb'
import { USER_ROLE } from '../../constant/actionTypes/role'
import { FORM_FIELDS_NAME } from '../sevenEnquiry/addEditSevenEnquiry/constant'
import { useForm } from 'react-hook-form'
import { Button } from 'primereact/button'
import { ROUTE_PATH } from '../../constant/urlConstant'
import { Calendar } from 'primereact/calendar'
import { useNavigate } from 'react-router-dom'
import { AutoComplete } from 'primereact/autocomplete'
import useIsMobile from '../../common/MobileDeviceHook'
// import MzAutoComplete from '../../common/MzForm/MzAutoComplete'
import moment from 'moment'

const LinkComponent = (props) => {
  const {
    fetchDistrictList,
    fetchSubDistrictList,
    fetchVillageList,
    // districtsList,
    // subDistrictsList,
    // villagesList,
    fetchLinkList,
    linksList,
    isPageLevelError,
    linkTableData,
    handleOnReadRecord,
    handleOnDeleteRecord,
    handleOnEditRecord,
    isLoading,
    userRole,
    handleOnCreatedRecord,
    handleOnDownloadRecord
  } = props.linkProps

  const { setValue, watch, reset } = useForm({})
  const isMobile = useIsMobile()
  const [paginationInfo, setPaginationInfo] = useState({
    pageSize: 10,
    pageNumber: 0,
    totalRecords: 0,
    totalPages: 0
  })
  const [query, setQuery] = useState('')
  const [startDateValue, setStartDateValue] = useState(null)
  const [endDateValue, setEndDateValue] = useState(null)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [openFilterTab, setFilterTab] = useState(null)
  const history = useNavigate()
    const formatedUTCDate = (date, isEndDate = false) => {
    if (!date) return null
    const dateObj = new Date(date)
    if (isEndDate) {
      dateObj.setHours(23, 59, 59, 999)
    } else {
      dateObj.setHours(0, 0, 0, 0)
    }
    const year = dateObj.getFullYear()
    const month = dateObj.getMonth()
    const day = dateObj.getDate()
    const hours = dateObj.getHours()
    const minutes = dateObj.getMinutes()
    const seconds = dateObj.getSeconds()
    const milliseconds = dateObj.getMilliseconds()
    const utcDate = new Date(
      Date.UTC(year, month, day, hours, minutes, seconds, milliseconds)
    )
    return utcDate.toISOString()
  }

  const handleStartDateChange = (e) => {
    const selectedStartDate = e.value
    setStartDateValue(selectedStartDate)
    if (selectedStartDate) {
      setStartDate(formatedUTCDate(selectedStartDate, false))
    } else {
      setStartDate(null)
      setEndDateValue(null)
      setEndDate(null)
    }
  }

  const handleEndDateChange = (e) => {
    const selectedEndDate = e.value
    setEndDateValue(selectedEndDate)
    if (selectedEndDate) {
      setEndDate(formatedUTCDate(selectedEndDate, true))
    } else {
      setEndDate(null)
    }
  }
  const isUser = userRole === USER_ROLE.USER
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (query.length > 3 || query === '' || isUser) {
        const payload = {
          query,
          pageNumber: 0,
          pageSize: 10,
          districtId: watch(FORM_FIELDS_NAME.DISTRICT.name) || null,
          talukaId: watch(FORM_FIELDS_NAME.SUB_DISTRICT.name) || null,
          villageId: watch(FORM_FIELDS_NAME.VILLAGE.name) || null
        }

        if (startDate && endDate) {
          payload.startDate = startDate
          payload.endDate = endDate
        }

        fetchLinkList(payload)
      }
    }, 300)

    return () => clearTimeout(delayDebounceFn)
  }, [
    query,
    fetchLinkList,
    startDate,
    endDate,
    watch(FORM_FIELDS_NAME.DISTRICT.name),
    watch(FORM_FIELDS_NAME.SUB_DISTRICT.name),
    watch(FORM_FIELDS_NAME.VILLAGE.name)
  ])

  useEffect(() => {
    fetchDistrictList()
    setValue(FORM_FIELDS_NAME.DISTRICT.name, '')
    setValue(FORM_FIELDS_NAME.SUB_DISTRICT.name, '')
    setValue(FORM_FIELDS_NAME.VILLAGE.name, '')

    // eslint-disable-next-line
  }, [fetchDistrictList, setValue])

  useEffect(() => {
    if (watch(FORM_FIELDS_NAME.DISTRICT.name)) {
      fetchSubDistrictList(watch(FORM_FIELDS_NAME.DISTRICT.name))
      setValue(FORM_FIELDS_NAME.SUB_DISTRICT.name, '')
      setValue(FORM_FIELDS_NAME.VILLAGE.name, '')
    }
    // eslint-disable-next-line
  }, [watch(FORM_FIELDS_NAME.DISTRICT.name), fetchSubDistrictList, setValue])

  useEffect(() => {
    if (watch(FORM_FIELDS_NAME.SUB_DISTRICT.name)) {
      fetchVillageList(watch(FORM_FIELDS_NAME.SUB_DISTRICT.name))
      setValue(FORM_FIELDS_NAME.VILLAGE.name, '')
    }
    // eslint-disable-next-line
  }, [watch(FORM_FIELDS_NAME.SUB_DISTRICT.name), fetchVillageList, setValue])
  const loadLazyData = (event) => {
    const { pageNumber, pageSize } = event
    setPaginationInfo((prev) => ({
      ...prev,
      pageNumber,
      pageSize
    }))

    fetchLinkList({
      query: query,
      pageNumber,
      pageSize,
      startDate: startDate,
      endDate: endDate
    })
  }

  const shouldRenderFullPageError = () => isPageLevelError
  const shouldRenderUserTransactionList = () =>
    linkTableData?.tableData?.columns?.length > 0
  const shouldRenderNotFoundView = () =>
    !shouldRenderFullPageError && !shouldRenderUserTransactionList

  const filters = {
    global: { value: null },
    userName: { filterKey: 'username', value: null },
    email: { filterKey: 'email', value: null }
  }

  const shouldRenderActiveColumn = () => userRole !== USER_ROLE.USER

  let columns = linkTableData?.tableData?.columns

  if (shouldRenderActiveColumn()) {
    columns = [
      ...columns,
      {
        colLabel: 'Active',
        dataKey: 'active',
        extraProps: {
          isSortable: false,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: 'Enter Active Status'
        }
      }
    ]
  }

  if (userRole === USER_ROLE.USER) {
    columns = columns.filter(
      (column) =>
        !['user.firstName', 'user.lastName', 'user.mobile'].includes(
          column.dataKey
        )
    )
  }
  const screenPermission =
    userRole === USER_ROLE.SUPER_ADMIN
      ? {
        ...linkTableData?.tableData?.screenPermission,
        update: true,
        download: true
      }
      : {
        ...linkTableData?.tableData?.screenPermission,
        update: false,
        download: false
      }

  const tableProps = {
    value:
      linksList?.content?.map((link) => ({
        ...link,
        // createdAt: moment(link.createdAt).format('DD/MMM/YYYY HH:mm ')
        createdAt: (() => {
          const utcMoment = moment.utc(link.createdAt)
          const localMoment = moment(link.createdAt)
          return `${utcMoment.format('DD/MMM/YYYY')} ${localMoment.format('HH:mm')}`
        })()
      })) ?? [],
    loading: isLoading,
    columns:
      userRole === USER_ROLE.SUPER_ADMIN
        ? columns
        : columns.filter((col) => col.colLabel !== 'Usage'),
    paginationInfo: {
      ...paginationInfo,
      totalRecords: linksList?.totalElements ?? 0
    },
    screenPermission,
    loadLazyData,
    emptyMessage: 'No Link Record Found',
    filters,
    sortField: null,
    showMoreAction: false,
    onReadRecord: handleOnReadRecord,
    onEditRecord: handleOnEditRecord,
    onDeleteRecord: handleOnDeleteRecord,
    onDownloadRecord: handleOnDownloadRecord
  }

  const handleToCreateLink = () => {
    handleOnCreatedRecord()
  }

  const renderPageHeaderSection = () => {
    const breadCrumbItems = [
      { label: 'Link', command: () => history(ROUTE_PATH.LINK.HOME) }
    ]
    const home = {
      icon: 'pi pi-home',
      command: () => history(ROUTE_PATH.DASHBOARD.HOME)
    }

    const handleFilterClick = () => {
      setFilterTab(true)
    }

    return (
      <div className="flex justify-content-between align-items-center border-1 border-200 border-round bg-white">
        <BreadCrumb model={breadCrumbItems} home={home} className="border-0" />

        <div className="mr-2 flex justify-content-between h-full align-items-center gap-3">
          <div className="flex" style={{ maxWidth: '600px' }}>
            {!isUser && (
              <div className="mr-2 mt-2 md:mr-3">
                <i
                  className="pi pi pi-filter text-green-400 text-2xl cursor-pointer"
                  onClick={handleFilterClick}
                ></i>
              </div>
            )}
          </div>
          {USER_ROLE.USER === userRole && (
            <div className="mb-2 w-10rem mt-1 p-1">
              <AutoComplete
                value={query}
                field="label"
                onChange={(e) => setQuery(e.value)}
                dropdown
                placeholder={
                  userRole === USER_ROLE.USER
                    ? 'Search By Plot...'
                    : 'Search By User...'
                }
              />
            </div>
          )}
          <div>
            {USER_ROLE.USER !== userRole && (
              <Button onClick={handleToCreateLink} className="py-2">
                Create Link
              </Button>
            )}
          </div>
        </div>
      </div>
    )
  }

  const handleCloseFilter = () => {
    if (isMobile) {
      setFilterTab(false)
    } else {
      setFilterTab(false)
      setValue(FORM_FIELDS_NAME.DISTRICT.name, '')
      setValue(FORM_FIELDS_NAME.SUB_DISTRICT.name, '')
      setValue(FORM_FIELDS_NAME.VILLAGE.name, '')
      setStartDateValue(null)
      setEndDateValue(null)
      setStartDate(null)
      setEndDate(null)
      setQuery('')
    }
  }
  const handleCloseFilterMobile = () => {
    setFilterTab(false)
  }

  // const selectedDistrict = watch('district')
  // const selectedSubDistrict = watch('taluka')
  // const selectedVillage = watch('village')
  // const getDistrictLabel = (districtId) => {
  //   const selectedDistrictObj = districtsList?.content?.find(
  //     (district) => district.id === districtId
  //   )
  //   return selectedDistrictObj ? selectedDistrictObj.name : ''
  // }
  // const getSubDistrictLabel = (subDistrictId) => {
  //   const selectedSubDistrictObj = subDistrictsList?.find(
  //     (subDistrict) => subDistrict.id === subDistrictId
  //   )

  //   return selectedSubDistrictObj ? selectedSubDistrictObj.name : ''
  // }

  // const getVillageLabel = (villageId) => {
  //   const selectedVillageObj = villagesList?.find(
  //     (village) => village.id === villageId
  //   )
  //   return selectedVillageObj ? selectedVillageObj.name : ''
  // }
  const handleReset = () => {
    setQuery('')
    setStartDateValue(null)
    setEndDateValue(null)
    setStartDate(null)
    setEndDate(null)
    reset({
      district: '',
      taluka: '',
      village: ''
    })
  }

  return (
    <div>
      {renderPageHeaderSection()}
      {shouldRenderFullPageError() && (
        <div>
          <ErrorPage />
        </div>
      )}

      {openFilterTab && !isMobile && !isUser && (
        <div className=" flex justify-content-end gap-2 h-5 w-full bg-white shadow-2 border-0 border-200 border-round bg-white mt-2">
          {/* <div className="mb-2 w-10rem mt-1 p-1">
            <MzAutoComplete
              control={control}
              name={FORM_FIELDS_NAME.DISTRICT.name}
              placeholder={FORM_FIELDS_NAME.DISTRICT.placeholder}
              suggestions={districtsList?.content ?? []}
              dropdown
              optionLabel={FORM_FIELDS_NAME.DISTRICT.optionLabel}
              optionValue={FORM_FIELDS_NAME.DISTRICT.optionValue}
            />
          </div> */}
          {/* <div className="w-10rem mt-1 p-1">
            <MzAutoComplete
              control={control}
              name={FORM_FIELDS_NAME.SUB_DISTRICT.name}
              suggestions={subDistrictsList ?? []}
              dropdown
              optionLabel={FORM_FIELDS_NAME.SUB_DISTRICT.optionLabel}
              optionValue={FORM_FIELDS_NAME.SUB_DISTRICT.optionValue}
              placeholder={FORM_FIELDS_NAME.SUB_DISTRICT.placeholder}
            />
          </div> */}
          {/* <div className="w-10rem mt-1 p-1">
            <MzAutoComplete
              control={control}
              name={FORM_FIELDS_NAME.VILLAGE.name}
              suggestions={villagesList ?? []}
              dropdown
              optionLabel={FORM_FIELDS_NAME.VILLAGE.optionLabel}
              optionValue={FORM_FIELDS_NAME.VILLAGE.optionValue}
              placeholder={FORM_FIELDS_NAME.VILLAGE.placeholder}
            />
          </div> */}
          <div className="w-12rem mt-1 p-1">
            <Calendar
              value={startDateValue}
              onChange={handleStartDateChange}
              readOnlyInput
              placeholder="Select Start Date"
              showIcon
              showButtonBar
              dateFormat="dd/mm/yy"
              maxDate={new Date()}
            />
          </div>
          <div className="w-12rem mt-1 p-1">
            <Calendar
              value={endDateValue}
              onChange={handleEndDateChange}
              readOnlyInput
              placeholder="Select End Date"
              showIcon
              showButtonBar
              dateFormat="dd/mm/yy"
              maxDate={new Date()}
              minDate={startDateValue}
              disabled={!startDateValue}
            />
          </div>

          <div className="mb-2 w-10rem mt-1 p-1">
            <AutoComplete
              value={query}
              field="label"
              onChange={(e) => setQuery(e.value)}
              dropdown
              placeholder={
                userRole === USER_ROLE.USER
                  ? 'Search By Plot...'
                  : 'Search By User...'
              }
            />
          </div>
          <div className="mt-2 p-2">
            {' '}
            <i
              className="pi pi-times-circle text-red-500 text-2xl cursor-pointer"
              onClick={handleCloseFilter}
            ></i>
          </div>
        </div>
      )}
      {openFilterTab && isMobile && (
        <Sidebar
          visible={openFilterTab}
          position="bottom"
          onHide={handleCloseFilterMobile}
          className="p-sidebar-md"
          modal={false}
          dismissable={false}
        >
          <div className="grid p-fluid">
            <div className="mb-2 w-25rem mt-1 p-1">
              <div className="p-inputgroup">

                <AutoComplete
                  value={query}
                  field="label"
                  onChange={(e) => setQuery(e.value)}
                  dropdown
                  placeholder={
                    userRole === USER_ROLE.USER
                      ? 'Search By Plot...'
                      : 'Search By User...'
                  }
                />
              </div>
            </div>
            <div className="grid mt-1 w-full">
              <div className="col-6 p-1">
                <Calendar
                  value={startDateValue}
                  onChange={handleStartDateChange}
                  readOnlyInput
                  placeholder="Select Start Date"
                  showIcon
                  showButtonBar
                  dateFormat="dd/mm/yy"
                  className="w-full"
                  maxDate={new Date()}
                />
              </div>
              <div className="col-6 p-1">
                <Calendar
                  value={endDateValue}
                  onChange={handleEndDateChange}
                  readOnlyInput
                  placeholder="Select End Date"
                  showIcon
                  showButtonBar
                  dateFormat="dd/mm/yy"
                  maxDate={new Date()}
                  disabled={!startDateValue}
                  className="w-full"
                />
              </div>
            </div>
            {/* <div className="mb-2 w-10rem mt-1 p-1">
              <MzAutoComplete
                control={control}
                name={FORM_FIELDS_NAME.DISTRICT.name}
                placeholder={FORM_FIELDS_NAME.DISTRICT.placeholder}
                suggestions={districtsList?.content ?? []}
                dropdown
                optionLabel={FORM_FIELDS_NAME.DISTRICT.optionLabel}
                optionValue={FORM_FIELDS_NAME.DISTRICT.optionValue}
                value={getDistrictLabel(selectedDistrict)}
              />
            </div>
            <div className="w-10rem mt-1 p-1">
              <MzAutoComplete
                control={control}
                name={FORM_FIELDS_NAME.SUB_DISTRICT.name}
                suggestions={subDistrictsList ?? []}
                dropdown
                optionLabel={FORM_FIELDS_NAME.SUB_DISTRICT.optionLabel}
                optionValue={FORM_FIELDS_NAME.SUB_DISTRICT.optionValue}
                placeholder={FORM_FIELDS_NAME.SUB_DISTRICT.placeholder}
                value={getSubDistrictLabel(selectedSubDistrict)}
              />
            </div>
            <div className="w-10rem mt-1 p-1">
              <MzAutoComplete
                control={control}
                name={FORM_FIELDS_NAME.VILLAGE.name}
                suggestions={villagesList ?? []}
                dropdown
                optionLabel={FORM_FIELDS_NAME.VILLAGE.optionLabel}
                optionValue={FORM_FIELDS_NAME.VILLAGE.optionValue}
                placeholder={FORM_FIELDS_NAME.VILLAGE.placeholder}
                value={getVillageLabel(selectedVillage)}
              />
            </div> */}

          </div>
          <div className="mt-4 p-1 flex justify-content-center align-items-center gap-3">
            <Button onClick={handleReset} className="w-10rem flex justify-content-center">
              Reset
            </Button>
            <Button onClick={() => setFilterTab(false)} className="w-10rem flex justify-content-center" severity="secondary">
              Close
            </Button>
          </div>
        </Sidebar>
      )}


      {shouldRenderUserTransactionList() && (
        <div className="border-1 border-200 border-round mt-3 p-2 bg-white">
          <MzTable {...tableProps} />
        </div>
      )}
      {shouldRenderNotFoundView() && <div>No record to show</div>}
    </div>
  )
}

export default LinkComponent
